import { FunctionComponent, useCallback, useMemo, useEffect } from 'react'
import { MdCheck } from 'react-icons/md'
import { useHistory } from 'react-router-dom'

import { ICreateCaminhao } from 'modules/caminhao/domain/usecases/CreateCaminhao'
import { IFindCaminhaoByDescricao } from 'modules/caminhao/domain/usecases/FindCaminhaoByDescricao'
import { useCaminhao } from 'modules/caminhao/hooks/useCaminhao'
import CaminhaoRoutes from 'modules/caminhao/utils/CaminhaoRoutes'
import { IFindAll } from 'modules/tipoCaminhao/domain/usecases/FindAll'
import { IListVeiculosImpl } from 'modules/veiculos/domain/usecases/ListVeiculosImpl'
import SnackBar from 'shared/components/SnackBar'

import iconConcluido from '../../../../shared/assets/icons/icon-concluido-blue.png'
import Button from '../../../../shared/components/Button'
import ContainerPage from '../../../../shared/components/ContainerPageNew'
import Modal from '../../../../shared/components/Modal'
import { colors } from '../../../../shared/styles/colors'
import HorsePlate from './components/HorsePlate'
import TruckPlate from './components/TruckPlate'
import TypeName from './components/TypeName'
import { Container, Icon, Text } from './styles'
import ModalSelectFrotista from 'shared/components/ModalSelectFrotista'

type TProp = {
  findAll: IFindAll
  findCaminhaoByDescricao: IFindCaminhaoByDescricao
  listVeiculos: IListVeiculosImpl
  createCaminhao: ICreateCaminhao
}

const CreateCaminhao: FunctionComponent<TProp> = ({
  findAll,
  findCaminhaoByDescricao,
  listVeiculos,
  createCaminhao,
}) => {
  const {
    nomeCaminhao,
    veiculo,
    tipoCaminhao,
    carreta1,
    carreta2,
    carreta3,
    step,
    error,
    setError,
    errorMessage,
    setCreateCaminhao,
    indiceCarreta,
    openModal,
    setOpenModal,
    openModalSelectFrotista,
    setOpenModalSelectFrotista,
  } = useCaminhao()
  const history = useHistory()

  useEffect(() => {
    setCreateCaminhao(createCaminhao)
  }, [])

  const handleCloseModal = useCallback(async () => {
    setOpenModal(false)

    history.push(CaminhaoRoutes.LIST)
  }, [history])

  const componentSteps = useMemo(() => {
    return [
      {
        component: (
          <TypeName
            findAll={findAll}
            findCaminhaoByDescricao={findCaminhaoByDescricao}
          />
        ),
      },
      {
        component: <HorsePlate listVeiculos={listVeiculos} />,
      },
      {
        component: <TruckPlate listVeiculos={listVeiculos} />,
      },
      {
        component: <TruckPlate listVeiculos={listVeiculos} />,
      },
      {
        component: <TruckPlate listVeiculos={listVeiculos} />,
      },
    ]
  }, [
    findAll,
    listVeiculos,
    indiceCarreta,
    findCaminhaoByDescricao,
    nomeCaminhao,
    veiculo,
    tipoCaminhao,
    tipoCaminhao,
    carreta1,
    carreta2,
    carreta3,
  ])

  return (
    <>
      {openModal && (
        <Modal size="small" openModal={openModal} showCloseButton={false}>
          <Container>
            <Icon src={iconConcluido} />

            <div>
              <Text>Caminhão Adicionado com sucesso!</Text>
            </div>

            <Button color={colors.orange} onClick={handleCloseModal}>
              <MdCheck />
              Concluir
            </Button>
          </Container>
        </Modal>
      )}

      {openModalSelectFrotista && (
        <ModalSelectFrotista
          openModalSelectFrotista={openModalSelectFrotista}
          setOpenModalSelectFrotista={setOpenModalSelectFrotista}
        />
      )}

      <ContainerPage
        breadCrumb="Caminhão / Adicionar caminhão"
        showScaffold={false}
      >
        {componentSteps[step].component}
      </ContainerPage>
      <SnackBar
        open={error}
        setOpen={setError}
        severity="error"
        message={errorMessage}
        horizontal="right"
      />
    </>
  )
}

export default CreateCaminhao
